/**
 * Avisos de "esta grabación cambió" para las tarjetas que la pintan (RecordingCard en Messaging,
 * InspectorMessages, ClaimChat, /rec/:id). Emiten: el socket (`recording.ready`, vía RecProvider) y
 * el propio flujo de grabación (complete, send, keep, rename, delete). Es un pub/sub mínimo por
 * documento: cada tarjeta se suscribe a SU id y relee `GET /:id` cuando le avisan — la fuente de
 * verdad sigue siendo el servidor, acá solo se despierta a quien mira.
 */
import type { RecordingDTO } from './types';

type Listener = (r: RecordingDTO | null, id: number) => void;
const listeners = new Map<number, Set<Listener>>();

export function onRecordingChange(id: number, cb: Listener): () => void {
  let set = listeners.get(id);
  if (!set) { set = new Set(); listeners.set(id, set); }
  set.add(cb);
  return () => { set!.delete(cb); if (!set!.size) listeners.delete(id); };
}

/** `recording` null = "releé el servidor" (p. ej. borrada). */
export function emitRecordingChange(id: number, recording: RecordingDTO | null): void {
  const set = listeners.get(id);
  if (!set) return;
  for (const cb of set) { try { cb(recording, id); } catch { /* un oyente roto no frena a los demás */ } }
}
